import React, { useEffect } from "react";
import {
  Row,
  Col,
  Card,
  Form,
  Button,
  Typography,
  message,
  Spin,
} from "../../common/utils/antd-imports/AntdImports";
import "./ContactPage.css";
import FloatingInput from "../../common/float-input/FloatInput";
import { useDispatch, useSelector } from "react-redux";
import { createContact } from "../../../store/thunks/authThunk";
import FloatingTextArea from "../../common/floating-textarea/FloatingTextArea";
import FloatingSelect from "../../common/floating-select/floatingSelect";
import BreadcrumbNav from "../../common/bread-crumbs/BreadCrumb";
import {
  allowAlphabetsWithInnerSpace,
  blockPasteInvalid,
  restrictNumbersAndExponential,
} from "../../common/utils/Utils";

const { Text } = Typography;
const ContactPage = () => {
  const star = <span style={{ color: "#d2042d" }}>*</span>;
  const floatingInputStyles = {
    marginTop: "0px",
    "--input-font-weight": "500",
    "--label-focused-top": "23px",
    "--label-focused-z-index": 1,
    "--label-focused-color": "#333",
    "--label-padding-left": "0.5rem",
  };
  const textAreaFloatingInputStyles = {
    "--input-height": "120px",
    "--label-font-size": "10px",
    "--input-font-weight": 500,
    "--input-padding-top": "1rem",
    "--label-focused-top": "22px",
    "--label-focused-z-index": 1,
    "--label-focused-color": "#333",
    "--label-padding-left": "10px",
  };
  const floatingSelectStyles = {
    marginTop: "0px",
    "--input-font-weight": "500",
    "--label-focused-top": "23px",
    "--label-focused-z-index": 1,
    "--label-focused-color": "#333",
    "--label-padding-left": "0.6rem",
    "--input-padding-top": "1rem",
  };
  const dispatch = useDispatch();
  const { contactStatus } = useSelector((state) => state.contact);
  const [form] = Form.useForm();
  const { isLoading } = useSelector((state) => state.contact);
  const formValues = Form.useWatch([], form);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleSubmit = (values) => {
    const utmSource = localStorage.getItem("utm_source");
    const payload = {
      name: `${values.firstName} ${values.lastName}`,
      email: values.email,
      contactno: values.phone,
      message: values.message,
      subject: values.subject,
      ...(utmSource && { utm_source: utmSource }),
    };

    dispatch(createContact(payload)).then((res) => {
      if (res?.payload?.status == 1) {
        message.success(
          res.payload.message || "Contact submitted successfully!",
        );
        form.resetFields();
      } else if (res.payload?.message) {
        message.error(
          res.payload?.message || "Something went wrong, please try again.",
        );
      }
    });
  };
  const isSubmitDisabled = () => {
    const hasErrors = form
      .getFieldsError()
      ?.some(({ errors }) => errors.length);
    const requiredFields = [
      "firstName",
      "lastName",
      "email",
      "phone",
      "subject",
      "message",
    ];
    const hasEmptyFields = requiredFields?.some((field) => {
      const value = form?.getFieldValue(field);
      return (
        value === undefined ||
        value === null ||
        value === "" ||
        (Array?.isArray(value) && value?.length === 0)
      );
    });

    return hasErrors || hasEmptyFields;
  };
  return (
    <div>
      <div className="contact-page">
        <div className="bread-crumb-static">
          <BreadcrumbNav />
        </div>
        <div className="container-contactPage">
          <Row justify="center" gutter={[16, 16]}>
            {/* Left Side Content */}
            <Col xs={24} md={12} lg={12} xl={12} className="content-column">
              <div className="get-in-touch-heading">Get in Touch with Us!</div>
              <div className="campaign-support-text">
                We’re here to help you bring your campaign vision to life.
                Whether you have questions, need assistance, or are ready to
                launch, our team is just a message away.
              </div>

              <div className="contact-details-laptopView">
                <div className="contact-detail email">
                  <a
                    href="mailto:info@advertisingmarketplace.com"
                    style={{ textDecoration: "none" }}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Text className="contact-detail email">
                      info@advertisingmarketplace.com
                    </Text>
                  </a>
                </div>
                <div className="customer-supportDiv">
                  <Row gutter={[16, 16]}>
                    <Col
                      xs={24}
                      md={12}
                      lg={12}
                      xl={12}
                      className="customer-support"
                    >
                      <div className="support-heading">Customer Support</div>
                      <div className="support-description">
                        Need assistance? Our team is ready to help with any
                        questions, concerns, or issues you might have. Reach
                        out, and we’ll get back to you promptly.
                      </div>
                    </Col>
                    <Col
                      xs={24}
                      md={12}
                      lg={12}
                      xl={12}
                      className="customer-support"
                    >
                      <div className="support-heading">
                        Suggestions & Feedback
                      </div>
                      <div className="support-description">
                        Your feedback drives us! If you have ideas, suggestions,
                        or thoughts on how we can improve, please share we’re
                        always eager to listen and grow.
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>

            {/* Right Side Form with Card */}
            <Col xs={24} md={12} lg={12} xl={12} className="form-column">
              <Card bordered={false} className="contact-page-card-css">
                <div className="card-header small-screen-size">
                  <h2>Let’s Make it Happen Together!</h2>
                  <p>
                    Reach out using the form below, and we’ll get back to you
                    soon!
                  </p>
                </div>

                <Form
                  form={form}
                  layout="vertical"
                  name="contact-form"
                  onFinish={handleSubmit}
                  initialValues={{
                    firstName: "",
                    lastName: "",
                    email: "",
                    phone: "",
                    message: "",
                    subject: null,
                  }}
                >
                  <Row gutter={[16, 16]}>
                    <Col xs={12} sm={12}>
                      <Form.Item
                        name="firstName"
                        rules={[
                          {
                            required: true,
                            message: "First Name is required!",
                          },
                        ]}
                      >
                        <FloatingInput
                          className="billboard-input-feild"
                          label={
                            <>
                              {`First Name `}
                              {star}
                            </>
                          }
                          onKeyDown={(e) => {
                            restrictNumbersAndExponential(e);
                          }}
                          onChange={allowAlphabetsWithInnerSpace}
                          onPaste={blockPasteInvalid}
                          customStyles={floatingInputStyles}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={12} sm={12}>
                      <Form.Item
                        name="lastName"
                        rules={[
                          {
                            required: true,
                            message: "Last Name is required!",
                          },
                        ]}
                      >
                        <FloatingInput
                          className="billboard-input-feild"
                          label={
                            <>
                              {`Last Name `}
                              {star}
                            </>
                          }
                          onKeyDown={(e) => {
                            restrictNumbersAndExponential(e);
                          }}
                          onChange={allowAlphabetsWithInnerSpace}
                          onPaste={blockPasteInvalid}
                          customStyles={floatingInputStyles}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12}>
                      <Form.Item
                        name="email"
                        rules={[
                          { required: true, message: "Email is required!" },
                          {
                            type: "email",
                            message: "Please enter a valid email!",
                          },
                        ]}
                      >
                        <FloatingInput
                          className="billboard-input-feild"
                          label={
                            <>
                              {`Email `}
                              {star}
                            </>
                          }
                          customStyles={floatingInputStyles}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12}>
                      <Form.Item
                        name="phone"
                        rules={[
                          {
                            required: true,
                            message: "Mobile Number is required!",
                          },
                        ]}
                      >
                        <FloatingInput
                          className="billboard-input-feild"
                          label={
                            <>
                              {`Mobile `}
                              {star}
                            </>
                          }
                          maxLength={10}
                          onKeyPress={(e) => {
                            if (!/^\d$/.test(e.key)) {
                              // Here we are restricting the exponential values and alphabets
                              e.preventDefault();
                            }
                          }}
                          customStyles={floatingInputStyles}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24}>
                      <Form.Item
                        name="subject"
                        rules={[
                          {
                            required: true,
                            message: "Subject is required!",
                          },
                        ]}
                      >
                        <FloatingSelect
                          className="billboard-select-feild"
                          label={
                            <>
                              {`Subject `}
                              {star}
                            </>
                          }
                          options={[
                            { id: "Pricing", name: "Pricing" },
                            { id: "Request a Demo", name: "Request a Demo" },
                            {
                              id: "Buyer Assistance",
                              name: "Buyer Assistance",
                            },
                            {
                              id: "Seller Assistance",
                              name: "Seller Assistance",
                            },
                            { id: "Media Inquiries", name: "Media Inquiries" },
                            {
                              id: "Billing/Accounting",
                              name: "Billing/Accounting",
                            },
                            { id: "RFP Status", name: "RFP Status" },
                            {
                              id: "API Documentation",
                              name: "API Documentation",
                            },
                            { id: "Other", name: "Other" },
                          ]}
                          customStyles={floatingSelectStyles}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24}>
                      <Form.Item
                        name="message"
                        rules={[
                          {
                            required: true,
                            message: "Share The Details is required!",
                          },
                        ]}
                      >
                        <FloatingTextArea
                          className="billboard-input-feild billboard-text-area"
                          label={
                            <>
                              {`Share the Details `}
                              {star}
                            </>
                          }
                          customStyles={textAreaFloatingInputStyles}
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Form.Item>
                    <Button
                      type="primary"
                      id="contact_support_btn"
                      htmlType="submit"
                      className="contact-submit-btn billboard-button-2"
                      className={`contact-submit-btn billboard-button-2 ${
                        isSubmitDisabled() ? "disabled-opacity" : ""
                      }`}
                      disabled={isSubmitDisabled()}
                      block
                    >
                      Submit
                    </Button>
                  </Form.Item>
                </Form>
                <div className="footer-text">
                  Looking forward to working with you to make something
                  extraordinary!
                </div>
              </Card>
            </Col>

            {/* Contact Details Below Form for Mobile */}
            <Col xs={24} className="contact-details-MobileView">
              <div className="contact-detail email">
                <a
                  href="mailto:info@advertisingmarketplace.com"
                  style={{ textDecoration: "none", color: "#d2042d" }}
                  className="contact-detail email"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  info@advertisingmarketplace.com
                </a>
              </div>
              <div className="customer-supportDiv">
                <Row gutter={[16, 16]}>
                  <Col xs={24} md={12} className="customer-support">
                    <div className="support-heading">Customer Support</div>
                    <div className="support-description">
                      Need assistance? Our team is ready to help with any
                      questions, concerns, or issues you might have. Reach out,
                      and we’ll get back to you promptly.
                    </div>
                  </Col>
                  <Col xs={24} md={12} className="customer-support">
                    <div className="support-heading">
                      Suggestions & Feedback
                    </div>
                    <div className="support-description">
                      Your feedback drives us! If you have ideas, suggestions,
                      or thoughts on how we can improve, please share—we’re
                      always eager to listen and grow.
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </div>
      </div>
      {isLoading && (
        <div className="loading-css">
          <Spin size="large" fullscreen />
        </div>
      )}
    </div>
  );
};

export default ContactPage;
